﻿import {useState, useRef, useEffect} from 'react';

// lib 
import { motion, AnimatePresence } from 'framer-motion';

// components
import Error from '../Form/Error'

const CheckboxSubQuestion = ({
    children,
    handleAnswer,
    showSubQuestion,
    setFreeText,
    setValid,
    valid,
   ...props
}) => {

    const [input, setInput] = useState('')
    const [errors, setErrors] = useState({})

    let empty = input === ''
    const inputRef = useRef()

    useEffect(() => {
        if (showSubQuestion === true) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 200)
        }
    }, [showSubQuestion])


    const handleChange = (event) => {
        event.persist()

        const element = event.target;
        let valid = element.validity.valid

        if (element.validity.valueMissing) {
            element.setCustomValidity('Fältet får inte lämnas tomt')
        } else {
            element.setCustomValidity('')
        }

        let message = element.validationMessage

        setErrors({
            ...errors,
            [event.target.name]: message
        })

        setValid(valid)

        setFreeText({ [event.target.name]: event.target.value, [event.target.id]: props.id })
    }

    return (
        <AnimatePresence key={props.key}>
            <motion.label
                className="pension-wizard-block__question__card__dropdown"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                htmlFor='QuestionId'>
                <span className="pension-wizard-block__question__card__dropdown__helptext">{props.text}:</span>
                <input
                    className={`${valid ? "valid" : "invalid"} `}
                    required
                    name='Answer'
                    ref={inputRef}
                    type="text"
                    id="QuestionId"
                    onKeyDown={(event) => event.key === "Enter" && event.preventDefault()}
                    onChange={handleChange}
                />
                {errors &&
                    <Error error={errors.Answer} />
                }

            </motion.label>
        </AnimatePresence>
     )
}

export default CheckboxSubQuestion;